import { createModule } from '../../createModule';
// Select wire fields explicitly so unrelated properties cannot enter a write body.
const toBody = (params) => ({
    strategy_name: params.strategy_name,
    strategy_type: params.strategy_type,
    is_internal: params.is_internal,
    active: params.active,
});
export const createStrategiesAPI = createModule(({ http }) => ({
    getAll: () => http.get('/v2/strategies'),
    options: () => http.get('/v2/strategies/options'),
    create: (params) => {
        const body = { ...toBody(params), currency_id: params.currency_id };
        return http.post('/v2/strategies', { body });
    },
    update: (params) => {
        const body = toBody(params);
        return http.patch(`/v2/strategies/${params.strategy_id}`, { body });
    },
}));
